import React from "react";

import { FlexContainer } from "@/components/Atoms/Box";

import {
  BreadcrumbWrapper,
  Home,
  Icon,
  Section,
  StyledBreadcrumb,
} from "./style";

const Breadcrumb = ({ section }) => (
  <BreadcrumbWrapper>
    <FlexContainer>
      <StyledBreadcrumb>
        <Home variant="routelink2" to="/faqs">
          FAQ's
        </Home>
        <Icon icon="icon-caret-right" />
        <Section variant="paragraph3" to="/faqs">
          Yoga - {section}
        </Section>
      </StyledBreadcrumb>
    </FlexContainer>
  </BreadcrumbWrapper>
);

export default Breadcrumb;
